'use client';

type TableSectionProps = {
  table: {
    contentStart?: boolean;
    headers: string[];
    rows: (string | number)[][];
  };
};

export function TableSection({ table }: TableSectionProps) {
  return (
    <div className="overflow-x-auto w-full">
      <table className={`w-full border-collapse border border-gray-200 text-sm ${table.contentStart ? '' : 'text-center'}`}>
        <thead>
          <tr className="bg-gray-50">
            {table.headers.map((header, i) => (
              <th
                key={i}
                className="border border-gray-200 px-4 py-2 font-semibold text-gray-700"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, i) => (
            <tr
              key={i}
              className="odd:bg-white even:bg-gray-50 hover:bg-blue-50 transition-colors"
            >
              {row.map((cell, j) => (
                <td
                  key={j}
                  className="border border-gray-200 px-4 py-2 text-gray-800"
                  dangerouslySetInnerHTML={{ __html: cell }}
                />
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
